<div class="retry-content">
  <div>
    <h2 class="confirm title header-text heavy-header-text" mat-dialog-title>
      {{ data.message }}
    </h2>
    <mat-dialog-content>
      <p id="link-area">
        {{ data.link }}
      </p>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="centered">
    <div class="save-cancel-button-row">
      <button
        id="form-submit-button"
        class="header-text"
        type="submit"
        mat-button
        (click)="submit()"
      >
        {{ 'Copy Link' | uppercase }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
